module.exports = __webpack_public_path__ + "img/sprinkle-8.33624316.webp";